
export const ItemTypes = {
    DIMENSION: "dimension"
};

export const DIMENSION_TYPE = {
    attribute: "attribute",
    event: "event"
};